import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["card", "close"];

    connect() {
        // Find the modal as a sibling element (since it's rendered outside the controller element)
        // Try nextElementSibling first, then fallback to querySelector in parent
        this.modalElement = this.element.nextElementSibling?.classList.contains("alumni-card-modal") 
            ? this.element.nextElementSibling 
            : this.element.parentElement?.querySelector(".alumni-card-modal");

        // Find the close button within the modal (since it's outside the controller scope)
        this.closeButton = this.modalElement?.querySelector(".alumni-card-modal__close");

        // Only add click listener if card target exists (for active type cards)
        if (this.hasCardTarget) {
            this.cardTarget.addEventListener("click", () => {
                this.open();
            });
        }

        // Add click listener to close button
        if (this.closeButton) {
            this.closeButton.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.close();
            });
        }

        // Close modal when clicking outside (on the backdrop)
        if (this.modalElement) {
            this.modalElement.addEventListener("click", (e) => {
                // Only close if clicking directly on the modal container, not its children
                if (e.target === this.modalElement) {
                    this.close();
                }
            });
        }
    }

    open() {
        if (this.modalElement) {
            this.modalElement.classList.add("is-open");
            window.lenis.stop();
        }
    }

    close() {
        if (this.modalElement) {
            this.modalElement.classList.remove("is-open");
            window.lenis.start();
        }
    }
}
